/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module UpgradeModule */

/**
 * @fileoverview Contains Ajs dependacy tokens for factories & services.
 * @author Vinay Jadhav
 */

/**
 * Ajs dependancy token for Upgrade Node.
 */
export const UPGRADE_NODE_TOKEN = 'UpgradeNode';
